import EventEmitter from 'events'

const { emit, removeAllListeners, on, once, removeListener, addListener } = new EventEmitter()
export { emit, removeAllListeners, on, once, removeListener, addListener }

// 小结单错误码
export const RECORD_ERROR_10001 = 'RECORD_ERROR_10001'

// 小结单赋值事件
export const BriefRecordAssign = 'BRIEF_RECORD_ASSIGN'

// 全局启动SOP流程
export const START_SOP = 'START_SOP'

// im --TO-- sop  通信key
export const IM_SOP_MESSAGE_KEY = 'IM_SOP_POST_MESSAGE'

// sop --TO-- call im 通信key
export const IM_POST_MESSAGE = 'IM_POST_MESSAGE'

//  通信给recordForm
export const POST_MESSAGE_TO_RECORD = 'POST_MESSAGE_TO_RECORD'

// 电话客服人工通话记录查看展示
export const SHOW_MESSAGE_RECORD = 'SHOW_MESSAGE_RECORD'
// 小结单通讯 推荐执行sop事件
export const RECOMMENDED_PERFORM_SOP = 'RECOMMENDED_PERFORM_SOP'

//  通信给recordForm 服务标准组件
// export const POST_MESSAGE_TO_SERVICE_STANDARD = 'POST_MESSAGE_TO_SERVICE_STANDARD'

//  通信给服务总结 服务指南业务类型
export const POST_MESSAGE_TO_SERVICE_DIRECTORY = 'POST_MESSAGE_TO_SERVICE_DIRECTORY'

// 通信给服务话术
export const POST_MESSAGE_TO_SERVICE_SCRIPT = 'POST_MESSAGE_TO_SERVICE_SCRIPT'

// 发起主动联系弹窗
export const CALL_IM_WORKBENCH = 'CALL_IM_WORKBENCH'

// 工作台回访跟进
export const WORKBENCH_FOLLOW_UP = 'WORKBENCH_FOLLOW_UP'

// 业务标签搜索模式
export const BIZ_TAG_SEARCH_MODE = 'BIZ_TAG_SEARCH_MODE'

// 技能组转接成功后移除会话
export const REMOVE_CALL_TRANSFER = 'REMOVE_CALL_TRANSFER'
export const GLOBAL_DIALOG = 'GLOBAL_DIALOG'

// 重复进线提醒
export const REPEAT_CALLING = 'REPEAT_CALLING'
// 风险单提醒
export const RISK_CASE = 'RISK_CASE '

// 运单号改变
export const ORDER_ID_CHANGE = 'ORDER_ID_CHANGE'

// 电话工作台事业部选择组件
export const CALL_BUSINESS_UNITS = 'CALL_BUSINESS_UNITS'
export const WBBIZ_TYPE_USER_ROLE = 'WBBIZ_TYPE_USER_ROLE'
export const WBBIZ_SELECT = 'WBBIZ_SELECT'

// 定位到指定模块的指定组件
export const HIGHLIGHT_ROLL = 'HIGHLIGHT_ROLL'

// 核心单据携带查询参数查询单据
export const CORE_REMOVE_SEARCH = 'CORE_REMOVE_SEARCH'
// 远程同步sop搜索组件
export const REMOTE_SYNCHRONIZATION_SOP = 'REMOTE_SYNCHRONIZATION_SOP'
// sop节点滚动定位
export const SOP_SCROLL_POSITION = 'SOP_SCROLL_POSITION'
// 更新服务跟进数据
export const UPDATE_FOLLOWUP_LIST = 'UPDATE_FOLLOWUP_LIST'

// 核心单据查询或同步单号到对应 列表选择节点查询事件 目前介入（运单 ， 投诉单 ， 协商单）
export const CORE_SYNC_SOP_NODE_SELECT = 'CORE_SYNC_SOP_NODE_SELECT'
// 更新事业部聚合信息tab
export const LINK_UPDATE_BUSINESS_UNIT_TABS = 'LINK_UPDATE_BUSINESS_UNIT_TABS'
// 更新sop日志
export const UPDATE_SOP_LOG = 'UPDATE_SOP_LOG'

// 更新sop 远程预测问题运单信息
export const UPDATE_SOP_FORECAST_INFO = 'UPDATE_SOP_FORECAST_INFO'

// 通知  标签组件展开下拉框
export const TOGGLE_DROPDOWN_VISIBLE = 'TOGGLE_DROPDOWN_VISIBLE'

// 通知  切换账号事件
export const PERSON_CHANGE = 'PERSON_CHANGE'

// sop  全局分享数据
export const SOP_SHARE_DATA = 'SOP_SHARE_DATA'

// sop 执行动作事件
export const SOP_EXECUTE_HANDLER = 'SOP_EXECUTE_HANDLER'

// sop 助手新流程接受事件
export const SOP_HELPER_EVENT = 'SOP_HELPER_EVENT'

// sop 节点同步标签到小结单
export const SYNC_SOP_BIZTYPE_TO_RECORD = 'SYNC_SOP_BIZTYPE_TO_RECORD'

// 工作台助手插件
export const WORKBENCH_UTIL_OPTIONS_EVENT = 'WORKBENCH_UTIL_OPTIONS_EVENT'
